let CURRENT_BLOG_ID;
const cookieLanguageKey = "userLanguage";

export const initLocationForms = () => {
  CURRENT_BLOG_ID = document.body?.dataset.blogId;

  // location banner
  const locationBanner = new LocationBanner();
  locationBanner.init();

  // init header form
  const locationForm = new LocationForm();
  locationForm.init();

  // init footer forms
  const locationAndLanguageForms = new LocationAndLanguageForms();
  locationAndLanguageForms.init();

  // clone and append language form in footer to header
  const targetDesk = document.querySelector(".js-lang-switcher");
  const targetMob = document.querySelector(".js-lang-switcher-mob");
  appendLangSwitchToHead(targetDesk);
  appendLangSwitchToHead(targetMob);

  const langFooters = document.querySelectorAll(".js-lang-selector-foot")
  langFooters.forEach(elem => {
    rewriteLangUrlsForPost(elem.querySelectorAll(".single-input"))
  })
}

/**
 * Helpers
 */
function appendLangSwitchToHead(target) {
  const langClone = document.querySelector(".js-lang-selector-foot")?.cloneNode(true);
  target?.appendChild(langClone);
  const h = langClone.style.getPropertyValue("--h");
  target?.style.setProperty("--h", h);
  const headerLangForm = new HeaderLanguagesForm(langClone);
  headerLangForm.init();
}

const cloneAndAppend = (current, clone, parent) => {
  if (clone) {
    current?.remove();
    parent.insertBefore(
      clone,
      parent?.querySelector(".single-input")
    );
  }
}

const setCookieUserChosenLanguage = blogPath => {
  const expirationDate = new Date();
  // expires in 1 week
  expirationDate.setDate(expirationDate.getDate() + 7);
  // check expiration in 10 seconds...
  //expirationDate.setTime(expirationDate.getTime()+(10*1000))
  const expirationDateString = expirationDate.toUTCString();

  document.cookie = `${cookieLanguageKey}=${blogPath}; expires=${expirationDateString}; path=/`;
  console.log(`${cookieLanguageKey}=${blogPath}; expires=${expirationDateString}; path=/`);
}

/**
 * Header lang selector
 */
class HeaderLanguagesForm {
  constructor(selector) {
    this.selector = selector;
    this.inputs = this.selector?.querySelectorAll(".single-input");
  }

  init() {
    this.selector?.addEventListener("click", (e) => {
      this.selector.classList.contains("is-open")
      ? this._closeSelector()
      : this._openSelector();
    });

    this.inputs?.forEach(input => {
      input.addEventListener("click", (e) => this._handleInputsLangClick(e));
    });
  }

  _handleInputsLangClick = e => {
    e.stopPropagation();

    this.selector?.querySelector(
      ".single-input.is-selected"
    )?.classList.remove("is-selected");
    e.target.classList.add("is-selected");

    setCookieUserChosenLanguage(e.target.dataset.blogPath);

    const isTargetBlank = e.target.dataset.openAs === "new-tab";
    if (!isTargetBlank) {
      window.location = e.target.dataset.blogPath;
    } else {
      window.open(e.target.dataset.blogPath, "_blank", "noopener, noreferrer");
    }
  }

  _openSelector = () => this.selector.classList.add("is-open");

  _closeSelector = () => {
    const selectedInput = this.selector.querySelector(".single-input.is-selected");
    const selectedClone = selectedInput?.cloneNode(true);

    this.selector.classList.remove("is-open");

    cloneAndAppend(selectedInput, selectedClone, this.selector);
  }
}

/**
 * Location banner
 */
class LocationBanner {
  constructor() {
    this.banner = document.querySelector(".js-nav-banner");
    this.btnClose = this.banner?.querySelector(".js-close");
    this.cookieCountry = this.banner?.querySelector(".js-location-selector")?.dataset.whatsMyCountry?.toLowerCase();
    this.currentMarket = window.location.pathname.split("/")[1];
    this.cookieUserChosenLanguage = this.getCookieUsrLang();
    console.log(`${this.cookieUserChosenLanguage 
      ? `user has chosen: ${this.cookieUserChosenLanguage}`
      : "user hasn't chosen any language preference."}`);
  }

  init = () => {
    if (
        !this.cookieUserChosenLanguage
        && this.cookieCountry
      ) {
        this._setCurrentLocationInBanner();

      if (this.cookieCountry !== this.currentMarket) {
        this.show();
      }
    }

    this.btnClose?.addEventListener("click", this.hide);
  }

  show = () => {
    this.banner?.classList.remove("is-hidden");
  }

  hide = () => {
    this.banner?.classList.add("is-hidden");
  }

  getCookieUsrLang = () => {
    return document.cookie
      .split("; ")
      .find(row => row.startsWith(
        `${cookieLanguageKey}=`
      ))?.split("=")[1];
  }

  // replace {BLOG_NAME} in location banner
  _setCurrentLocationInBanner = () => {
    const bannerTxt = this.banner?.querySelector(".nav-banner-txt")?.textContent;
    const currentLocationCode = document.querySelector(
        `.single-input[data-blog-id="${CURRENT_BLOG_ID}"]`
      )?.dataset.locationCode;
    const currentLocBlogName = this.banner.querySelector(
        `.single-input[data-location-code=${currentLocationCode}]`
      )?.dataset.blogName;
    const innerHTMLReplaced = this.banner
      .querySelector(
        ".nav-banner-txt"
      )?.innerHTML?.replace(
        "{BLOG_NAME}", currentLocBlogName
      );
    this.banner.querySelector(".nav-banner-txt").innerHTML = innerHTMLReplaced;
  }
}

/**
 * Header form
 */
class LocationForm {
  constructor() {
    this.form = document.querySelector(".js-nav-banner .js-location-form");
    this.selector = this.form?.querySelector(".js-location-selector");
    this.inputs = this.selector?.querySelectorAll(".single-input");
    this.btnSubmit = this.form?.querySelector(".js-btn-submit");
  }

  init = () => {
    this._selectCurrentLoc();

    this.selector?.addEventListener("click", (e) => {
      this.selector.classList.contains("is-open")
      ? this._closeSelector()
      : this._openSelector();
    });

    this.inputs?.forEach(input => {
      input.addEventListener("click", this._handleInputClick);
    });

    this.btnSubmit?.addEventListener("click", (e) => {
      const selectedLang = this.selector.querySelector(".single-input.is-selected")?.dataset?.blogPath;
      this._closeSelector();

      // set cookie with chosen language
      setCookieUserChosenLanguage(selectedLang);

      // redir
      window.location = selectedLang;
    })

    this._setUpSelectorHeight(this.selector);
  }

  _setUpSelectorHeight = selector => {
    const selectorPaddingBlock = 16;
    const selectorLabelHeight = selector?.querySelector(".toggle-selector")?.offsetHeight;
    let totalH = 0;

    selector?.querySelectorAll(".single-input")?.forEach(input => {
      if (!input.classList.contains("is-disabled")) {
        totalH += input.offsetHeight;
      }
    });

    selector?.setAttribute(
      "style",
      `--h: ${totalH + selectorPaddingBlock + selectorLabelHeight}px`
    );
  }

  _openSelector = () => {
    this.selector.classList.add("is-open");
  }

  _closeSelector = () => {
    const selectedInput = this.selector.querySelector(".single-input.is-selected");
    const selectedClone = selectedInput?.cloneNode(true);

    this.selector.classList.remove("is-open");

    if (selectedClone) {
      selectedInput?.remove();
      this.selector.insertBefore(
        selectedClone,
        this.selector.querySelector(".single-input")
      );
    }

    this._updateInputs();
  }

  _handleInputClick = e => {
    e.stopPropagation();

    if (this.selector.classList.contains("is-open")) {
      this.selector.querySelector(".single-input.is-selected")?.classList.remove("is-selected");
      e.target.classList.add("is-selected");
    }

    this._closeSelector();
  }

  _updateInputs = () => {
    this.inputs = this.selector.querySelectorAll(".single-input");

    this.inputs?.forEach(input => {
      input.removeEventListener("click", this._handleInputClick);
      input.addEventListener("click", this._handleInputClick);
    });
  }

  _selectCurrentLoc = () => {
    const myCountry = this.selector?.dataset.whatsMyCountry?.toLowerCase();
    const input = this.selector?.querySelector(`[data-location-code="${myCountry}"]`);
    input?.classList.add("is-selected");

    const inputClone = input?.cloneNode(true);

    cloneAndAppend(input, inputClone, this.selector);
  }
}

/**
 * Footer forms
 */
class LocationAndLanguageForms {
  constructor() {
    this.form = document.querySelector(".js-loc-and-lang-cont");
    this.selectorLoc = this.form?.querySelector(".js-location-selector-foot");
    this.selectorLang = this.form?.querySelector(".js-lang-selector-foot");
    this.inputsLoc = this.selectorLoc?.querySelectorAll(".single-input");
    this.inputsLang = this.selectorLang?.querySelectorAll(".single-input");
  }

  init = () => {
    this._selectCurrentLocAndLang();

    this.selectorLoc?.addEventListener("click", (e) => {
      this.selectorLoc.classList.contains("is-open")
      ? this._closeSelector(this.selectorLoc)
      : this._openSelector(this.selectorLoc);
    });

    this.selectorLang?.addEventListener("click", (e) => {
      this.selectorLang.classList.contains("is-open")
      ? this._closeSelector(this.selectorLang)
      : this._openSelector(this.selectorLang);
    });

    this.inputsLoc?.forEach(input => {
      input.addEventListener("click", this._handleInputsLocClick);
    });

    this.inputsLang?.forEach(input => {
      input.addEventListener("click", this._handleInputsLangClick);
    });

    this._setUpSelectorHeight(this.selectorLoc);
    this._setUpSelectorHeight(this.selectorLang);
  }

  _setUpSelectorHeight = selector => {
    const selectorPaddingBlock = 16;
    const selectorLabelHeight = selector?.querySelector(".toggle-selector")?.offsetHeight;
    let totalH = 0;

    selector?.querySelectorAll(".single-input")?.forEach(input => {
      if (!input.classList.contains("is-disabled")) {
        totalH += input.offsetHeight;
      }
    });

    selector?.setAttribute(
      "style",
      `--h: ${totalH + selectorPaddingBlock + selectorLabelHeight}px`
    );
  }

  _selectCurrentLocAndLang = () => {
    const inputLang = Array.from(
        this.inputsLang
      )?.filter(
        input => window.location.pathname.includes(input.dataset.blogPath)
      ).sort(
        (a, b) => b.dataset.blogPath.length - a.dataset.blogPath.length
      )[0];
    const inputLoc = this.selectorLoc?.querySelector(
        `[data-location-code="${inputLang?.dataset.locationCode}"]`
      );

    inputLang?.classList.add("is-selected");
    inputLoc?.classList.add("is-selected");

    const inputLangClone = inputLang?.cloneNode(true);
    const inputLocClone = inputLoc?.cloneNode(true);

    cloneAndAppend(inputLang, inputLangClone, this.selectorLang);
    cloneAndAppend(inputLoc, inputLocClone, this.selectorLoc);
    this._hideUnsupportedLangs(inputLang?.dataset.locationCode);
  }

  _hideUnsupportedLangs = locationCode => {
    Array.from(
      this.inputsLang
    )?.filter(
      input => input.dataset.locationCode !== locationCode
    )?.forEach(i => i.classList.add("is-disabled"));
  }

  _handleInputsLocClick = e => {
    e.stopPropagation();

    if (this.selectorLoc?.classList.contains("is-open")) {
      this.selectorLoc.querySelector(
        ".single-input.is-selected"
      )?.classList.remove("is-selected");
      e.target.classList.add("is-selected");
    }

    setCookieUserChosenLanguage(`/${e.target.dataset.locationCode}`);
    window.location = this.selectorLang?.querySelector(
        `[data-location-code="${e.target?.dataset.locationCode}"]`
      )?.dataset.blogPath;
  }

  _handleInputsLangClick = e => {
    e.stopPropagation();

    this.selectorLang?.querySelector(
      ".single-input.is-selected"
    )?.classList.remove("is-selected");
    e.target.classList.add("is-selected");

    setCookieUserChosenLanguage(e.target.dataset.blogPath);
    window.location = e.target.dataset.blogPath;
  }

  _openSelector = selector => selector.classList.add("is-open");

  _closeSelector = selector => {
    const selectedInput = selector.querySelector(".single-input.is-selected");
    const selectedClone = selectedInput?.cloneNode(true);

    selector.classList.remove("is-open");

    cloneAndAppend(selectedInput, selectedClone, selector);
  }
}


// Rewrites Language url for current post
/**
 @typedef Translation
 @type {Object}
 @property {String} url
 @property {String} post_id
 @property {String} language_code
 @property {Boolean} is_current
 */
/**
 @typedef TranslationsMap
 @type {Object.<String, Translation>}
 */

// Type Defs
/**
 * @param {NodeListOf<HTMLElement>} elems
 * @return {String|undefined}
 */
const getSelectedBlogId = (elems) => {
  const elemForBlogId = [...elems].find(elem => elem.dataset.blogId && elem.classList.contains('is-selected'))
  return (elemForBlogId && elemForBlogId.dataset.blogId) || undefined
}

/**
 * @param {String} blogId
 * @param {NodeListOf<HTMLElement>} elems
 * @return {HTMLElement[]}
 */
const selectNodesForBlogId =  (blogId, elems) => [...elems].filter(elem => elem.dataset.blogId === blogId)

/**
 * @param {NodeListOf<HTMLElement>} elems
 */
const rewriteLangUrlsForPost = (elems) => {
  /**
   * @type {TranslationsMap|undefined}
   */
  const translationsMap =  window["translationsMap"] || undefined
  const blogId = getSelectedBlogId(elems)
  /**
   * @type {HTMLElement[]}
   */
  const blogElems = (blogId && selectNodesForBlogId(blogId, elems)) || []

  blogElems.forEach(elem => {
    const languageCode = (elem.dataset.languageCode || "").toLowerCase()
    /**
     * @type {Translation|undefined}
     */
    const translation = (translationsMap && translationsMap[languageCode]) || undefined
    const url = translation?.url ?? undefined

    if (url) {
      elem.dataset.blogPath = url
      elem.dataset.openAs = undefined
    } else {
      elem.dataset.openAs = "new-tab"
    }
  })
}
